// this file is generated by build/compile-schemas.js
import { validateCompiled, } from '../validator.js';
import { searchTherapistSearchParamsSchema, } from './UserApi.js';
import { searchTherapistSearchParams, } from './UserApiCoercing.generated.mjs';
export function searchTherapistSearchParamsValidateCoercing(props) {
    return validateCompiled(searchTherapistSearchParams, structuredClone(props));
}
//# sourceMappingURL=UserApiCoercing.binding.js.map